import { createAction, union, props } from '@ngrx/store';

import { Stage, UpgradeError } from '../../interfaces';

export const setStage = createAction('[One Upgrade Status] stage', props<{ stage: Stage }>());

export const setError = createAction('[One Upgrade Status] set Error', props<{ error: UpgradeError }>());

export const clearErrors = createAction('[One Upgrade Status] clear Error');

export const clearPending = createAction('[One Upgrade Status] clear Pending');

export const setWaitlisted = createAction('[One Upgrade Status] set Waitlisted', props<{ waitlisted: boolean }>());

export const setSplitPNR = createAction('[One Upgrade Status] set SplitPNR', props<{ splitPNR: boolean }>());

const all = union({ setStage, clearErrors, clearPending, setWaitlisted, setSplitPNR });
export type StatusActionsUnion = typeof all;
